<template>
    <div class="ContactDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.EntityContact.Person.AKA ? props.rowData.EntityContact.Person.FirstName  + ' &quot;' + props.rowData.EntityContact.Person.AKA + '&quot; ' + props.rowData.EntityContact.Person.LastName  : props.rowData.EntityContact.Person.FullName"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddContact()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-contact" :title="ModalContactTitle" hide-footer :modal-class="IncludeCharting ? 'full-screen-modal' : ''" @show="ProfessionalDropdownEnabled == true ? GetAllContactsInSubProgram() : ''">
            <b-container v-if="EditMode == false && TargetContact.EntityContact">
                <b-row>
                    <b-col>
                        <h3>Name</h3>
                        <p><span class="bold">First Name: </span>{{ TargetContact.EntityContact.Person.FirstName }}</p>
                        <p><span class="bold">Last Name: </span>{{ TargetContact.EntityContact.Person.LastName }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <p v-if="TargetContact.EntityContact.Person.Email"><span class="bold">Email: </span>{{ TargetContact.EntityContact.Person.Email }}</p>
                        <p v-for="(phoneNumber, phoneIndex) in TargetContactPhoneNumbers">
                            <span class="bold">{{ phoneNumber.PhoneType }}: </span>{{ phoneNumber.PhoneNumber }} {{ phoneNumber.Description ? '(' + phoneNumber.Description + ')' : '' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Assignment Details</h3>
                        <p><span class="bold">Contact Type: </span>{{ TargetContact.EntityContact.ContactCategory }}</p>
                        <p v-if="TargetContact.EntityContact.Agency"><span class="bold" v-if="DisplayChurch == true">Church: </span><span class="bold" v-else>Agency: </span>{{ TargetContact.EntityContact.Agency }}</p>
                        <p><span class="bold">Relationship to {{ RelationshipLabel }}: </span>{{ TargetContact.ContactRelationship }}</p>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetContact.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetContact.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelContact()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditContact">
                    <PersonEditor :edit-mode="true"
                                  :existing-person="TargetContact.EntityContact ? TargetContact.EntityContact.Person : null"
                                  :DOBRequired="false"
                                  :global-update="GlobalUpdate"
                                  :inline="true"
                                  end-point="tbd"
                                  :control-buttons="false"
                                  :include-pnw-family-tracking="false"
                                  :include-pnw-babysitter-tracking="false"
                                  :hide-personal-info="true"
                                  ref="contact-add-editor"
                                  :is-strong-family-contactable="false" />
                    <b-row>
                        <b-col>
                            <h3>Assignment Details</h3>
                            <div class="form-group" v-if="AgencyInput && TargetContact.EntityContact">
                                <label>Agency:</label>
                                <input class="form-control" v-model="TargetContact.EntityContact.Agency" />
                            </div>
                            <div class="form-group" v-if="DisplayChurch && TargetContact.EntityContact">
                                <label>Church:</label>
                                <input class="form-control" v-model="TargetContact.EntityContact.Agency" />
                            </div>
                            <div class="form-group">
                                <label>Relationship to {{ RelationshipLabel }}:</label>
                                <div v-if="Array.isArray(RelationshipOptions)">
                                    <select class="form-control" v-model="TargetContact.ContactRelationship" required>
                                        <option v-for="option in RelationshipOptions" :value="option.value">{{ option.text }}</option>
                                    </select>
                                </div>
                                <div v-else-if="RelationshipOptions">
                                    <input class="form-control" required v-model="TargetContact.ContactRelationship" readonly />
                                </div>
                                <div v-else>
                                    <input class="form-control" required v-model="TargetContact.ContactRelationship" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetContact.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetContact.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelContact()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteContact()" type="button" v-if="TargetContact.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import PersonEditor from '../../../../Core/ItemEditors/PersonEditor.vue';
    import { EventBus } from '../../../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "LoadedRecords",//array
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "DeleteWarning",//string
            "DisplayAgency",//bool
            "DisplayAge",//bool
            "DisplayRelationship",//bool
            "AgencyInput", //bool
            "ChurchInput", //bool
            "DisplayAgency",//bool
            "DisplayChurch",//bool
            "RequireDob",//bool
            "ContactCategory",//string
            "RelationshipOptions",//array or string or null
            "RelationshipLabel",//string
            "IncludeCharting",//bool
            "SubProgramId",//string
            "HidePersonalInfo",//bool
        ],
        data: function () {
            return {
                selected: [],
                TargetContact: {},
                ModalContactTitle: "",

                Options: [],
                ContactSchema: {
                    Id: "",
                    StartDate: "",
                    EndDate: "",
                    ContactRelationship: "",
                    EntityContactID: "",
                    EntityContact: {
                        Id: "",
                        ContactCategory: "",
                        Agency: "",
                        PersonID: "",
                        Person: {
                            FirstName: "",
                            LastName: "",
                            Email: "",
                            PhoneNumbers: [],
                        }
                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                }

            };
        },
        methods: {
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            ShowDetailView(contact) {
                this.TargetContact = JSON.parse(JSON.stringify(contact));

                if (this.EditMode) {
                    this.ModalContactTitle = "Editing " + contact.EntityContact.Person.FullName;
                } else {
                    this.ModalContactTitle = "Viewing " + contact.EntityContact.Person.FullName;
                }
                this.$refs["modal-contact"].show();
            },
            ShowAddContact() {
                this.TargetContact = JSON.parse(JSON.stringify(this.ContactSchema));
                this.ModalContactTitle = "Add New " + this.ContactCategory;
                if (!Array.isArray(this.RelationshipOptions) && this.RelationshipOptions) {
                    this.TargetContact.ContactRelationship = this.RelationshipOptions;
                }
                this.TargetContact.EntityContact.ContactCategory = this.ContactCategory;
                this.$refs["modal-contact"].show();
            },
            AddEditContact(e) {
                e.preventDefault();
                //get person data here
                this.TargetContact.EntityContact.Person = this.$refs["contact-add-editor"].GetUpdatedPerson();
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint, { ...this.TargetContact, ...this.AddEditPayload }, this.AddEditContactSuccess, () => { }, true);

            },
            AddEditContactSuccess(response) {
                EventBus.$emit('profile-update-needed', response.data.data.CommunityFamilyID);
                this.$refs["modal-contact"].hide();
            },
            DeleteContact() {
                this.$MasterAPI.ExecuteRequest("DELETE", this.DeleteEndpoint + "/" + this.TargetContact.Id, { }, this.DeleteContactSuccess, () => { }, true);

            },
            DeleteContactSuccess(response) {
                EventBus.$emit('profile-update-needed', this.TargetContact.CommunityFamilyID);
                this.$refs["modal-contact"].hide();
            },
            CancelContact() {
                this.selected = {};
                this.$refs['modal-contact'].hide();
            },
            CancelDelete() {
                this.$refs['modal-delete'].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            flatPickr,
            Vuetable,
            PersonEditor,
            vSelect
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    }
                ];

                if (vm.DisplayRelationship) {
                    fieldData.push(
                        {
                            name: "ContactRelationship",
                            title: "RELATIONSHIP"
                        }
                    );
                }
                if (vm.DisplayAgency) {
                    fieldData.push(
                        {
                            name: "EntityContact.Agency",
                            title: "AGENCY"
                        }
                    );
                }
                if (vm.DisplayChurch) {
                    fieldData.push(
                        {
                            name: "EntityContact.Agency",
                            title: "CHURCH"
                        }
                    );
                }
                if (vm.DisplayAge) {
                    fieldData.push(
                        {
                            name: "EntityContact.Person.AgeString",
                            title: "AGE"
                        }
                    );
                }


                fieldData.push(
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                fieldData.push(
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                );
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            TargetContactPhoneNumbers: function () {
                let phoneNumbers = [];
                if (this.TargetContact.EntityContact) {
                    this.TargetContact.EntityContact.Person.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            phoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                return phoneNumbers;

            },
            ContactFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.SubProgramId);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "EntityContact");
            },

        },
        mounted() {
        },

    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr.current-record {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }


    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
    /*
    .vue-datatable th,
    .vue-datatable td {
        width: 150px; /* Set a fixed width for each column 
    }
    */
        .vue-datatable th:nth-child(1),
        .vue-datatable td:nth-child(1) {
            width: 25%; /* Adjust width for the first column */
        }

        .vue-datatable th:nth-child(2),
        .vue-datatable td:nth-child(2) {
            width: 25%; /* Adjust width for the second column */
        }

        .vue-datatable th:nth-child(3),
        .vue-datatable td:nth-child(3) {
            width: 20%; /* Adjust width for the second column */
        }

        .vue-datatable th:nth-child(4),
        .vue-datatable td:nth-child(4) {
            width: 15%; /* Adjust width for the second column */
        }

        .vue-datatable th:nth-child(5),
        .vue-datatable td:nth-child(5) {
            width: 15%; /* Adjust width for the second column */
        }

    /* Add more column-specific widths as needed */
</style>
